import React from "react"
import propTypes from "prop-types"
import { connect } from "react-redux"
import "./styles.scss"
import {
  signUpGuardian,
  signInGuardian,
  signUpGuardianInfo
} from "../../../../services/authentication"

import Form, { Group, Input, Password } from "../../../../components/Form"
import Header from "../../../../components/Header"
import Button from "../../../../components/Button"

class SignUpGuardian extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        preferred_name: {
          label: "Your preferred name",
          name: "preferred_name",
          type: "text",
          value: "",
          required: true,
          class: "",
          message: ""
        },
        password: {
          label: "Create Password",
          name: "password",
          type: "password",
          hide: true,
          value: "",
          required: true,
          class: "",
          message: ""
        },
        confirm_password: {
          label: "Confirm Password",
          name: "confirm_password",
          type: "password",
          hide: true,
          value: "",
          required: true,
          requiredField: "password",
          class: "",
          message: ""
        }
      },
      isSubmitted: false,
      currentStep: 1,
      token: "",
      errorMessage: "",
      innerLoading: false
    }
  }

  componentDidMount() {
    const { match } = this.props

    this.setState({
      token: match.params.token
    })
  }

  onChange = (name, field, value) => {
    const { form } = this.state

    this.setState({
      form: {
        ...form,
        [name]: {
          ...form[name],
          message: "",
          [field]: value
        }
      }
    })
  }

  onSubmit = e => {
    e.preventDefault()

    const { form, token } = this.state
    const {
      onSignUpGuardian,
      onSignInGuardian,
      onSignUpGuardianInfo
    } = this.props

    this.setState({ innerLoading: true })

    onSignUpGuardian(form, token)
      .then(res => {
        onSignInGuardian(res.access).then(() => {
          onSignUpGuardianInfo(res.access).then(() => {
            this.setState({
              currentStep: 2,
              innerLoading: false
            })
          })
        })
      })
      .catch(res => {
        if (res.fields) {
          this.setState({
            isSubmitted: true,
            innerLoading: false,
            form: { ...form, ...res.fields }
          })
        } else {
          this.setState({
            isSubmitted: true,
            innerLoading: false,
            errorMessage: res.errorMessage
          })
        }
      })
  }

  render() {
    const { user, isLogged, regPage2Data } = this.props
    const {
      form,
      isSubmitted,
      currentStep,
      innerLoading,
      errorMessage
    } = this.state

    return (
      <div className="guardians-registration">
        {(() => {
          switch (currentStep) {
            case 1:
              return (
                <div className="step-1">
                  <Header
                    theme="light"
                    user={user}
                    isLogged={isLogged}
                    hideNotifications
                  />

                  <div className="container-fluid">
                    <div className="row step-1">
                      <div className="col-md-12">
                        <div className="guardians-registration_item">
                          <Form
                            onSubmit={this.onSubmit}
                            className="form--light"
                          >
                            <h2 className="content_section_title">
                              Please enter your details to create your account
                            </h2>

                            {errorMessage && (
                              <div className="form_message form_message--global">
                                {errorMessage}
                              </div>
                            )}

                            <Group>
                              <Input
                                onChange={this.onChange}
                                isSubmitted={isSubmitted}
                                field={form.preferred_name}
                              />
                            </Group>

                            <Group>
                              <Password
                                onChange={this.onChange}
                                isSubmitted={isSubmitted}
                                field={form.password}
                              />
                            </Group>

                            <Group>
                              <Password
                                onChange={this.onChange}
                                isSubmitted={isSubmitted}
                                field={form.confirm_password}
                              />
                            </Group>

                            <Group className="form_group--padding-top-lg">
                              <Button
                                button={{
                                  type: "submit",
                                  disabled: innerLoading
                                }}
                                className="btn--secondary-light btn--width-md btn--height-sm"
                              >
                                Get access
                              </Button>
                            </Group>
                          </Form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            case 2:
              return (
                <div className="step-2">
                  <div className="container-fluid">
                    <div className="row align-items-center">
                      <div className="col-md-12">
                        <div className="guardians-registration_item">
                          <h2 className="content_section_title">
                            {regPage2Data.title}
                          </h2>

                          <div className="content_section_description">
                            {regPage2Data.text}
                          </div>

                          <div className="guardians-registration_list">
                            <div className="row">
                              {regPage2Data.items &&
                                regPage2Data.items.map((item, index) => {
                                  const key = `guardinas-registration-list-item-${index}`

                                  return (
                                    <div key={key} className="col-12 col-sm-6">
                                      <div className="guardians-registration_list_item">
                                        {item}
                                      </div>
                                    </div>
                                  )
                                })}
                            </div>
                          </div>

                          <Group className="form_group--padding-top-lg">
                            <Button
                              routerLink={{
                                to: "/"
                              }}
                              className="btn--secondary-light btn--width-full btn--height-lg btn--font-size-md"
                            >
                              Let’s get started
                            </Button>
                          </Group>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            default:
              return null
          }
        })()}
      </div>
    )
  }
}

SignUpGuardian.propTypes = {
  user: propTypes.shape({
    name: propTypes.string
  }).isRequired,
  isLogged: propTypes.bool.isRequired,
  regPage2Data: propTypes.shape({
    title: propTypes.string,
    text: propTypes.string,
    items: propTypes.arrayOf(propTypes.string)
  }).isRequired,
  onSignUpGuardian: propTypes.func.isRequired,
  onSignInGuardian: propTypes.func.isRequired,
  onSignUpGuardianInfo: propTypes.func.isRequired,
  match: propTypes.shape({
    params: propTypes.shape({
      token: propTypes.string
    })
  }).isRequired
}

const mapStateToProps = ({ AuthenticationReducer }) => ({
  user: AuthenticationReducer.user,
  isLogged: AuthenticationReducer.isLogged,
  regPage2Data: AuthenticationReducer.regPage2Data
})

const mapDispatchToProps = dispatch => ({
  onSignUpGuardian: (user, token) => dispatch(signUpGuardian(user, token)),
  onSignInGuardian: access => dispatch(signInGuardian(access)),
  onSignUpGuardianInfo: token => dispatch(signUpGuardianInfo(token))
})

export default connect(mapStateToProps, mapDispatchToProps)(SignUpGuardian)
